import Vue from 'vue';
import ECharts from 'vue-echarts'; // refers to components/ECharts.vue in webpack
import 'echarts';

// register component to use
Vue.component('v-chart', ECharts);
